module.exports = __webpack_public_path__ + "media/images/bengali-matrimony-banner-277d852814b9eb112737f16841b6692f.jpg";